/* angular:styles/component:css;808e0a72c477c99857adfdf1279c8e4335b47d8838f7bac7a28ae714227cd7fa;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/tasks/map/task-list-actions.component.ts */
.icon {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.75rem;
}
/*# sourceMappingURL=task-list-actions.component.css.map */
